import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = ({ error }) => (
  <div className="error-message">{error}</div>
);

export default ErrorMessage;
